export const LowerAllButFirstLetter = (input: string): string =>
  input
    .toLowerCase()
    .split(' ')
    .map((l) => l.charAt(0).toUpperCase() + l.slice(1))
    .join(' ');
